
// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Overview page components
import Header from "layouts/profile/components/Header";
import Account from "layouts/profile/components/Account";
import Branding from "layouts/profile/components/Branding";
import Subscription from "layouts/profile/components/Subscription";
import Addons from "layouts/profile/components/Addons";
import Usage from "layouts/profile/components/Usage";
import Users from "layouts/profile/components/Users";

import SocialProfiles from "layouts/profile/components/SocialProfiles";
import Workspaces from "layouts/profile/components/Workspaces"; // [NEW]


import AuthService from "services/auth-service";

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MDSnackbar from "components/MDSnackbar";

function Overview() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialTab = parseInt(searchParams.get("tab")) || 0;

  const [tabValue, setTabValue] = useState(initialTab);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);

  // Snackbar State
  const [successSB, setSuccessSB] = useState(false);
  const [infoSB, setInfoSB] = useState(false);
  const [sbMessage, setSbMessage] = useState("");

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openInfoSB = () => setInfoSB(true);
  const closeInfoSB = () => setInfoSB(false);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const response = await AuthService.getProfile();
        const userRole = response.data.attributes.role;
        setRole(userRole);
      } catch (error) {
        console.error("Failed to fetch user role", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, []);

  // Check for Addon Purchase Params
  useEffect(() => {
    if (!location) return;
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.get("addon_success") === "true") {
      setTabValue(4); // Switch to Addons Tab
      setSbMessage("Purchase successful! Your add-on has been activated.");
      openSuccessSB();

      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname + "?tab=4");
    }
    else if (searchParams.get("addon_cancel") === "true") {
      setTabValue(4);
      setSbMessage("Purchase cancelled.");
      openInfoSB();

      window.history.replaceState({}, document.title, window.location.pathname + "?tab=4");
    }
    else if (searchParams.get("tab") === "subscription") {
      setTabValue(3);
      window.history.replaceState({}, document.title, window.location.pathname + "?tab=3");
    }
  }, [location]);

  // 🔥 Persist tab state in URL
  useEffect(() => {
    const currentPath = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("tab", tabValue);
    window.history.replaceState({}, document.title, `${currentPath}?${searchParams.toString()}`);
  }, [tabValue]);

  const renderContent = () => {
    if (loading) {
      return <div>Loading...</div>; // or use a spinner component
    }

    switch (tabValue) {
      case 0: return <Account />;
      case 1: return <Workspaces />;
      case 2: return <Branding />;
      case 3: return <Subscription />;
      case 4: return <Addons />;
      case 5: return <Usage />;
      case 6: return role === "Admin" ? <Users /> : <Unauthorized />;
      case 7: return role === "Admin" ? <SocialProfiles /> : <Unauthorized />;
      default: return <Account />;
    }
  };

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Success"
      content={sbMessage}
      dateTime="now"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const renderInfoSB = (
    <MDSnackbar
      color="info"
      icon="info"
      title="Notification"
      content={sbMessage}
      dateTime="now"
      open={infoSB}
      onClose={closeInfoSB}
      close={closeInfoSB}
      bgWhite
    />
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      {!loading && role && (
        <Header tabValue={tabValue} setTabValue={setTabValue} />
      )}
      <MDBox mt={1}>{renderContent()}</MDBox>
      <Footer />
      {renderSuccessSB}
      {renderInfoSB}
    </DashboardLayout>
  );
}

export default Overview;

